/** @format */

const formatValue = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const num = Number(value);

  if (!isFinite(num)) return "";

  const parts = num.toString().split(".");

  if (parts.length === 2 && parts[1].length > 2) {
    return `${parts[0]}.${parts[1].slice(0, 2)}`;
  }

  return num;
};

export default formatValue;
